import { COUNTRIES_DATA } from './data/countries-data';
import { LANGUAGES_DATA } from './data/languages-data';
var Language = /** @class */ (function () {
    function Language(languageData, countryCode, countryData) {
        if (countryCode === void 0) { countryCode = ''; }
        this.languageName = languageData.name;
        this.languageLocal = languageData.local;
        this.iso639 = languageData.code;
        if (countryData) {
            this.country = {
                name: countryData.name,
                local: countryData.local,
                code: countryCode
            };
        }
    }
    Object.defineProperty(Language.prototype, "code", {
        /**
         * Browser language code.
         */
        get: function () {
            if (!this.country) {
                return this.iso639;
            }
            return this.iso639 + "-" + this.country.code;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Language.prototype, "name", {
        /**
         * Common name of language with country.
         */
        get: function () {
            if (!this.country) {
                return this.languageName;
            }
            return this.languageName + " (" + this.country.name + ")";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Language.prototype, "local", {
        /**
         * Local (cultural) name of language with country.
         */
        get: function () {
            if (!this.country) {
                return this.languageLocal;
            }
            return this.languageLocal + " (" + this.country.local + ")";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns serialized Language object (some libraries aren't handling objects correctly e.g. select2)
     */
    Language.prototype.serialized = function () {
        return {
            languageName: this.languageName,
            languageLocal: this.languageLocal,
            iso639: this.iso639,
            code: this.code,
            name: this.name,
            local: this.local
        };
    };
    return Language;
}());
export { Language };
var allCache;
/**
 * Fetch all available languages.
 */
export function all() {
    if (allCache) {
        return allCache;
    }
    prepareAllCache();
    return allCache;
}
/**
 * Fetch all available countries.
 */
export function allCountries() {
    return Object.keys(COUNTRIES_DATA).map(function (code) {
        var countryData = COUNTRIES_DATA[code];
        return { code: code, name: countryData[0], local: countryData[1] };
    });
}
/**
 * Find desired language via full language code
 * @param languageCode - language code
 */
export function find(languageCode) {
    if (!allCache) {
        prepareAllCache();
    }
    var lowercasedLanguageCode = languageCode.toLowerCase();
    return (allCache.find(function (l) { return l.code.toLowerCase() === lowercasedLanguageCode; }) || null);
}
export function findCountry(countryCode) {
    var country = COUNTRIES_DATA[countryCode];
    return country
        ? { name: country[0], local: country[1], code: countryCode }
        : null;
}
function prepareAllCache() {
    var languages = [];
    LANGUAGES_DATA.forEach(function (l) {
        var languageData = {
            name: l[0],
            local: l[1],
            code: l[2],
            countries: l[3]
        };
        languages.push(new Language(languageData));
        if (!languageData.countries) {
            return;
        }
        languageData.countries.forEach(function (countryCode) {
            languages.push(new Language(languageData, countryCode, findCountry(countryCode)));
        });
    });
    allCache = languages;
}
